import React from 'react'
import Activity from '../Pages/Activity'

const ActivityPreview = ({
  activityId, setActivityPreviewModal, withoutEditing,
  event, setEvent, data, phaseIndex
}) => {
  return (
    <>
      <Activity
        selectedActivity={activityId}
        setActivityPreviewModal={setActivityPreviewModal}
        withoutEditing={withoutEditing}
        event={event}
        data={data}
        phaseIndex={phaseIndex}
        setEvent={setEvent}
        previewOnly
      />
    </>
  )
}

export default ActivityPreview
